import http from '~/common/http'

export const STATUS_OFF = 0; // 下架状态
export const STATUS_ON = 1 // 上架状态

export default {
    // 产品列表
    getList(params) {
        return http.get('/api/products/index', {
            params: params
        });
    },

    // 获取指定产品信息
    getInfo(productId) {
        return http.get('/api/products/view', {
            params: {
                id: productId
            }
        });
    },
    
    //删除指定产品
    del(productId) {
        return http.delete('/api/products/delete', {
            params: {
                id: productId
            }
        })
    },

    // 创建产品
    create(params) {
        return http.post('/api/products/create', params)
    },

    // 编辑产品信息
    update(params) {
        return http.put('/api/products/update', params);
    },

    //激活产品
    activeProduct(params) {
        return http.put('/api/products/update', params);
    },

    /**
     * 得到产品列表 (用于渲染 Select 组件)
     * ~~~
     * 响应示例：
     * [
     *  {
     *     ”id“: "1",
     *     "name": "校网通"
     *  }
     * ]
     * ~~~
     */
    getOptionList() {
        return http.get('/api/products/option-list');
    },
}


// WEBPACK FOOTER //
// ./src/services/product.js